import { Injectable } from '@angular/core';
import { SharedService } from '../shared.service';
import { Observable } from 'rxjs';
import { appConfig } from '../../app.config';
@Injectable({
  providedIn: 'root'
})
export class ForgotPasswordService {

  constructor(private sharedService: SharedService) { }

  sendUserName(userName: any): Observable<any> {
    const ApiUrl = appConfig.forgetPassword;
    return this.sharedService.postDataForForgotPassword(`${ApiUrl}?username=${userName}`);
  }
}
